import { createContext } from 'react'
import { IKanbanContext, ISolicitacaoKanban } from './types'

const SolicitacoesKanbanContext = createContext<
  IKanbanContext<ISolicitacaoKanban>
>({} as any)

export default SolicitacoesKanbanContext
